<template>
  <chart-card title="Primeiras compras" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-integer />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    firstPurchases: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        units: this.stateFilters.unitsConfiguration,
        loyalty: true,
        segments: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.firstPurchases.map((object) => object.data)],
        datasets: [
          {
            label: 'Primeiras compras',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.firstPurchases.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      loyaltyFirstPurchasesChart: 'primeiras-compras',
    }),

    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.loyaltyFirstPurchasesChart({ group_by_fields: ['ano', 'mes'], ...this.filtro }).then((data) => {
            this.firstPurchases = helpers.agrupamentoMensal(data, 'NUM_CLIENTES')
          })
        }

        if (this.filterType === 'semanal') {
          await this.loyaltyFirstPurchasesChart({ group_by_fields: ['ano', 'semana'], ...this.filtro }).then((data) => {
            this.firstPurchases = helpers.agrupamentoSemanal(data, 'NUM_CLIENTES')
          })
        }

        if (this.filterType === 'diario') {
          await this.loyaltyFirstPurchasesChart({ group_by_fields: ['anomesdia'], ...this.filtro }).then((data) => {
            this.firstPurchases = helpers.agrupamentoDiario(data, 'NUM_CLIENTES')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
